import React, { useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress, MenuItem, TextField, Typography } from "@material-ui/core";
import api from "../../services/api";
export function parseTelegramTopics(value) {
  try { const data = typeof value === "string" ? JSON.parse(value) : value; return data && typeof data === "object" && !Array.isArray(data) ? data : {}; } catch { return {}; }
}
export default function TelegramCampaignTopicSelect({ group, value, onChange, disabled }) {
  const generation = useRef(0);
  const [search, setSearch] = useState("");
  const [topics, setTopics] = useState([]);
  const [next, setNext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  const path = `/groups/${group.whatsappId}/${encodeURIComponent(group.groupId)}/telegram-topics`;
  useEffect(() => {
    generation.current += 1;
    let active = true;
    setLoading(true); setError(""); setNext(null);
    const timer = setTimeout(() => {
      api.get(path, { params: { q: search } }).then(({ data }) => {
        if (active) { setTopics(data.topics || []); setNext(data.next); }
      }).catch(() => { if (active) setError("No se pudieron cargar los temas. Reintenta antes de elegir el destino."); })
        .finally(() => { if (active) setLoading(false); });
    }, search ? 300 : 0);
    return () => { active = false; clearTimeout(timer); };
  }, [path, search, retry]);
  const loadMore = async () => {
    const currentGeneration = generation.current;
    setLoading(true); setError("");
    try {
      const { data } = await api.get(path, { params: { q: search, ...next } });
      if (currentGeneration !== generation.current) return;
      setTopics(previous => [...new Map([...previous, ...(data.topics || [])].map(topic => [topic.id, topic])).values()]);
      setNext(data.next);
    } catch { if (currentGeneration === generation.current) setError("No se pudieron cargar más temas."); }
    finally { if (currentGeneration === generation.current) setLoading(false); }
  };
  const selectedMissing = value && !topics.some(topic => topic.id === Number(value));
  return (
    <Box px={2} pb={2} pt={1} style={{ minWidth: 0 }}>
      <Typography variant="body2" gutterBottom>Enviar a un tema de {group.name}</Typography>
      <TextField id={`topic-search-${group.whatsappId}-${group.groupId}`} fullWidth size="small" variant="outlined" label="Buscar tema (ej. Publicidad)"
        value={search} onChange={event => setSearch(event.target.value)} disabled={disabled} />
      <TextField id={`topic-destination-${group.whatsappId}-${group.groupId}`} select SelectProps={{ displayEmpty: true }} InputLabelProps={{ shrink: true }} fullWidth size="small" variant="outlined" margin="dense" label="Tema de destino"
        value={value || ""} onChange={event => onChange(event.target.value ? Number(event.target.value) : null)} disabled={disabled || loading}
        helperText="Sin un tema elegido, se envía a General. Los temas cerrados no se pueden seleccionar.">
        <MenuItem value="">General (predeterminado)</MenuItem>
        {selectedMissing && <MenuItem value={Number(value)}>Tema #{value} (selección guardada)</MenuItem>}
        {topics.map(topic => <MenuItem key={topic.id} value={topic.id} disabled={topic.closed || topic.hidden}>
          {topic.title}{topic.closed ? " · Cerrado" : topic.hidden ? " · Oculto" : ""}
        </MenuItem>)}
      </TextField>
      {loading && <CircularProgress size={18} aria-label="Cargando temas" />}
      {error && <Box><Typography variant="caption" color="error">{error}</Typography><Button size="small" disabled={disabled || loading} onClick={() => setRetry(n => n + 1)}>Reintentar</Button></Box>}
      {next && !error && <Button size="small" disabled={disabled || loading} onClick={loadMore}>Cargar más temas</Button>}
    </Box>
  );
}
